import { useState, useCallback } from 'react';
import { useNotifications } from 'src/hooks/useNotifications';
import { documentService } from 'src/services/services/documents/documents.api';
import {
  NotificationTypes,
  PubSubNotificationTypes,
} from 'src/enums/Notifications';
import { sendFailureNotification } from 'src/utils/notifications';

export const useFileUpload = () => {
  const [uploadStatus, setUploadStatus] = useState<
    'idle' | 'uploading' | 'success' | 'error'
  >('idle');
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const client = useNotifications()?.client;

  const uploadFile = useCallback(
    async (file: File, sessionId: string): Promise<string | undefined> => {
      setUploadStatus('uploading');
      setUploadedFile(file);
      try {
        const res = await documentService.uploadDoc(file, sessionId);
        if (!res) {
          throw new Error('Error uploading file');
        }

        return res;
      } catch (error) {
        console.error('Error uploading file:', error);
        setUploadStatus('error');
        throw error;
      }
    },
    [client]
  );

  return {
    uploadStatus,
    uploadedFile,
    uploadFile,
    setUploadedFile,
    client,
    setUploadStatus,
  };
};
